<template>
    <div class="notification-bar" :style="styleNotification">
        <!-- I'll use a table against my will. The only way I found to center vertically
             the close button regardless of the height of the text -->
        <table :style="styleTable">
            <tr>
                <td class="side-col"></td>
                <td class="large-col">
                    <component :is="htmlText"></component>
                </td>
                <td class="side-col">
                    <a v-on:click="hide($event)" class="close-button">
                        <i class="fa fa-times"></i>
                    </a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
    props: {
        text: String,
        color: String,
        timer: String
    },

    data() {
        return {
            timeout: undefined,
            barHeight: 0,
            tableEl: undefined,
            isAnimating: false
        };
    },

    computed: {
        isVisible() {
            return this.text && (!this.timer || this.timeout);
        },

        styleNotification() {
            var style = {};

            if (this.isAnimating) {
                style.height = this.barHeight + 'px';
            } else if (this.barHeight === 0) {
                style.height = '0px';
            } else {
                style.height = 'auto';
            }

            if (this.color) {
                style['background-color'] = this.color;
            }

            return style;
        },

        styleTable() {
            if (this.isAnimating) {
                return {
                    position: 'absolute'
                };
            }

            if (this.barHeight === 0) {
                return {
                    position: 'absolute'
                };
            }

            // Set the table position and wrapper height to default so that it adjusts itself
            // with the content when the browser windows is resized.
            return {
                position: 'static'
            };
        },

        htmlText() {
            if (this.text && this.text != '') {
                return {
                    template: '<div>' + this.text.replace(/{/g, "<a v-on:click='click'>").replace(/}/g, '</a>') + '</div>',
                    methods: {
                        click: function() {
                            this.$emit('notification-click');
                        }.bind(this)
                    }
                }
            }
        }
    },

    mounted() {
        this.tableEl = this.$el.querySelector('table');
    
        function onAnimationEnd() {
            this.isAnimating = false;
        }

        this.$el.addEventListener('transitionend', onAnimationEnd.bind(this), false);
        this.$el.addEventListener('webkitTransitionEnd', onAnimationEnd.bind(this), false);
        this.$el.addEventListener('oTransitionEnd', onAnimationEnd.bind(this), false);
        this.$el.addEventListener('msTransitionEnd', onAnimationEnd.bind(this), false);

        this.show();
    },

    watch: {
        text() {
            if (this.text && this.text !== '') {
                this.show();
            } else {
                this.hide();
            }
        }
    },

    methods: {
        show() {
            if (!this.text || this.text === '') {
                return;
            }

            // Transition the wrapper of the table to its new height
            this.isAnimating = true;
            this.barHeight = this.tableEl.offsetHeight;

            if (!this.timer) {
                return;
            }

            // Close after timeout;
            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
                this.timeout = undefined;
                this.barHeight = 0;
            }, parseInt(this.timer));
        },

        hide(event) {
            if (event) {
                event.stopPropagation();
            }

            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = undefined;
            }

            this.isAnimating = true;
            this.barHeight = this.tableEl.offsetHeight;

            // Animate height on next iteration otherwise it won't animate.
            setTimeout(() => this.barHeight = 0, 20);
        }
    }
};

</script>

<style lang="scss">

.notification-bar {
  position: relative;
  width: 100%;
  height: 0;
  font-family: "Poppins", sans-serif;
  background-color: #d4451d;
  color: white;

  transition-property: height;
  transition-duration: 0.4s;
  transition-timing-function: ease-out;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.side-col {
    min-width: 50px;
}

.large-col {
    width: 100%;
}

.close-button {
    color: white;
    font-size: 1.6em;
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    cursor: pointer;
}

table {
    position: absolute;
    bottom: 0;
    text-align: center;

    a {
        cursor: pointer;
    }
}

</style>



// WEBPACK FOOTER //
// NotificationBar.vue?30529020